/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { CustomForm } from './CustomForm';
import { DeliveryForm } from './DeliveryForm';
import { InvoiceForm } from './InvoiceForm';



export default function SalesOrderCreate(props) {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { type, orderId } = useParams();
    const formRef = useRef('');
    const dispatch = useDispatch();
    const [view, setView] = useState(false);
    const { history } = props; const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);

    useEffect(() => {
        if (!orderId && (type === 'view' || type === 'edit')) {
            history.push('/sales/sales-management/sales-order');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Sales Order', type, history, 'Sales')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }
    }, [orderId, type, roleManagement]);


    const loadTask = () => {
        if (orderId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: orderId, url: "v1/sales-order/sales-orders" });
        }
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view' || readDetails?.OrderStatus === 'DELIVERED' || readDetails?.OrderStatus === 'INVOICED' || readDetails?.OrderStatus === 'ORDERED' ||
                (readDetails?.inAppTransition && readDetails?.OrderStatus === 'SUBMITTED')
                || readDetails?.OrderStatus === 'ACCEPTED' || readDetails?.OrderStatus === 'CANCELLED') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Sales Order ID is invalid');
                history.push('/sales/sales-management/sales-order');
            }
        }
    }, [readDetails, readError]);


    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Sales Order', 'link': '' }]}
                closeLink={(type === 'delivery' || type === 'invoice') ? '' : '/sales/sales-management/sales-order'}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    {
                        type === 'delivery' ? <DeliveryForm
                            ref={formRef}
                            showDetails={showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        /> : type === 'invoice' ? <InvoiceForm
                            ref={formRef}
                            showDetails={showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        /> : <CustomForm
                            ref={formRef}
                            showDetails={type === 'create' ? false : showDetails}
                            view={view}
                            orderId={orderId}
                            type={type}
                            roleManagement={roleManagement}
                            loadTask={() => loadTask()}
                            classes={classes}
                            dispatch={dispatch}
                            clsx={clsx}
                            {...props}
                        />
                    }
                </div>
            </div>
        </Fragment>
    )
}